module.exports = __webpack_public_path__ + "static/media/titan-card.01aa12ab.png";